import { CallTranscriptSpeech } from 'services/api/getCallTranscript';

/**
 * Gets the mock audio file URL for testing purposes
 * Returns the URL of the actual OGG audio file
 */
export const getMockAudioUrl = (): string => {
    // Use require to import the OGG file - webpack will handle the path lifex
    // return require('./a63c70e6-cb85-4ed7-b991-9b995fc558cd.ogg') as string;
    // return require('./82e1b771-ec9a-447f-b1b6-f60c72db64ec.ogg') as string;
    return require('./37e468cf-cbd2-4f4d-9c7f-b991e0faa2fa.ogg') as string;
};

/**
 * Gets the mock audio as a Blob (for compatibility with existing code)
 * Fetches the OGG file and returns it as a Blob
 */
export const getMockAudioBlob = async (): Promise<Blob> => {
    const audioUrl = getMockAudioUrl();
    const response = await fetch(audioUrl);
    const blob = await response.blob();
    return blob;
};

/**
 * Mock call info for testing
 */
export const getMockCallInfo = () => ({
    name: 'Maria Rodriguez',
    callDate: 'January 15, 2024',
    callTime: '2:30 PM',
});

/**
 * Mock transcript data with proper timestamp_ns values
 * Timestamps are in nanoseconds, starting from a base time
 */
export const getMockTranscript = (): CallTranscriptSpeech[] => {
    // Base timestamp (January 15, 2024, 2:30:00 PM in nanoseconds)
    // const baseTimestamp = new Date('2024-01-15T14:30:00Z').getTime() * 1e6; // Convert to nanoseconds

    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const entries_mock_lifex = [
        {
            order: 1,
            speaker: 'user',
            text: 'Hello.',
            timestamp_ns: 1768224925841963500,
        },
        {
            order: 2,
            speaker: 'assistant',
            text: "Hi, Lucas, this is Laura? from Compass Health Insurance? How's it GOING today!",
            timestamp_ns: 1768224929949893400,
        },
        {
            order: 3,
            speaker: 'user',
            text: 'Doing fine.',
            timestamp_ns: 1768224932586156500,
        },
        {
            order: 4,
            speaker: 'assistant',
            text: "AWESOME, that's GREAT to hear. Now, I believe you JUST filled out a form on either Facebook or instagram, requesting information on self-employed health insurance? Well, there's a new plan that 'just' came out, and the monthly premiums are forty percent lower than ANYTHING we've seen, and the coverage is FANTASTIC! Are you still looking?",
            timestamp_ns: 1768224949614591700,
        },
        {
            order: 5,
            speaker: 'user',
            text: 'Sí.',
            timestamp_ns: 1768224952475306500,
        },
        {
            order: 6,
            speaker: 'assistant',
            text: "Excellent, well you've DEFINITELY come to the right place! Now, two quick things before we dive in: first, I just want you to know that I'm an advanced AI trained on ALL things health insurance, and I promise to do an AMAZING job for you. And second? we record these calls for training purposes. Now, are you looking for coverage just for yourself? or is it also for a spouse or any dependents.",
            timestamp_ns: 1768224972744593200,
        },
        {
            order: 7,
            speaker: 'user',
            text: 'Yes. Only for myself.',
            timestamp_ns: 1768224977750538800,
        },
        {
            order: 8,
            speaker: 'assistant',
            text: 'Perfect; so tell me a little bit about your current situation, what has you looking for coverage right now?',
            timestamp_ns: 1768224982920146700,
        },
        {
            order: 9,
            speaker: 'user',
            text: 'Changing shops.',
            timestamp_ns: 1768224988198816500,
        },
        {
            order: 10,
            speaker: 'assistant',
            text: "Understood Now, in terms of your new plan, do you have a certain dollar-amount in mind for what you'd like your new monthly premium to be?",
            timestamp_ns: 1768224995662852000,
        },
        {
            order: 11,
            speaker: 'user',
            text: 'Not really.',
            timestamp_ns: 1768224999626084600,
        },
        {
            order: 12,
            speaker: 'assistant',
            text: "Okay, thanks for sharing that. So, for solid PPO coverage? you're looking at a monthly premium of as little as three hundred dollars and as much as six hundred dollars, depending on the plan. I'll explain everything to you shortly, but for now, how does that range sound to you?",
            timestamp_ns: 1768225013681079600,
        },
        {
            order: 13,
            speaker: 'user',
            text: 'Sounds good.',
            timestamp_ns: 1768225016833613800,
        },
        {
            order: 14,
            speaker: 'assistant',
            text: "Totally understand, Lucas. Since these private plans are medically underwritten and start around two hundred and fifty dollars a month, the best fit for your budget is likely an ACA plan, and many people qualify for subsidies that can lower the monthly cost; if you'd like, I can have one of our licensed ACA specialists reach out in the next twenty-four hours to walk you through the lowest-cost options and handle enrollment - what's the best way to reach you, phone or email?",
            timestamp_ns: 1768225041722911200,
        },
        {
            order: 15,
            speaker: 'user',
            text: 'Information',
            timestamp_ns: 1768225046760467700,
        },
    ];

    // Transcript entries with relative times (in seconds from start)
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const entries = [
        {
            order: 1,
            speaker: 'assistant',
            text: 'Hola, ¿es Lucas?',
            timestamp_ns: 1767809423746311200,
        },
        {
            order: 2,
            speaker: 'user',
            text: 'Hola.',
            timestamp_ns: 1767809425732355600,
        },
        {
            order: 3,
            speaker: 'assistant',
            text: 'Hola, habla Sofia Perez de Brigante Law Group. ¿Cómo estás hoy?',
            timestamp_ns: 1767809429807956500,
        },
        {
            order: 4,
            speaker: 'user',
            text: 'Bien, bien.',
            timestamp_ns: 1767809437180366300,
        },
        {
            order: 5,
            speaker: 'assistant',
            text: 'Me alegra saber que estás bien. Ahora, si recuerdas, recientemente llenaste un formulario en Facebook o Instagram, solicitando información sobre cómo arreglar tus papeles sin salir del país. ¿Recuerdas?',
            timestamp_ns: 1767809449408516000,
        },
        {
            order: 6,
            speaker: 'user',
            text: 'Sí, claro.',
            timestamp_ns: 1767809451429115400,
        },
        {
            order: 7,
            speaker: 'assistant',
            text: 'Okay, genial! DEFINITIVAMENTE has llegado al lugar correcto. Ahora, antes de comenzar, solo quiero que sepas que, como somos una firma de Abogados, grabamos todas nuestras llamadas tanto por motivos de cumplimiento como por tu protección. ¿Estás de acuerdo con eso?',
            timestamp_ns: 1767809473440599300,
        },
        {
            order: 8,
            speaker: 'user',
            text: 'Sí. K.',
            timestamp_ns: 1767809476430496500,
        },
        {
            order: 9,
            speaker: 'assistant',
            text: 'Perfecto. ¿Ahora, cómo prefieres que te llame? ¿Está bien Lucas, o prefieres otro nombre?',
            timestamp_ns: 1767809481511481900,
        },
        {
            order: 10,
            speaker: 'user',
            text: 'Lucas, está bien.',
            timestamp_ns: 1767809484531003000,
        },
        {
            order: 11,
            speaker: 'assistant',
            text: 'Bueno, es un placer conocerte, Lucas. De nuevo, mi nombre es Sofia, y soy una IA entrenada por el Abogado Eduardo. Todo lo que me digas es cien por ciento confidencial. Entonces, permíteme hacerte un par de preguntas rápidas para ver si potencialmente calificas para arreglar tus papeles. Ahora, ¿estás actualmente casado con un ciudadano de los Estados Unidos o un residente legal permanente?',
            timestamp_ns: 1767809506870254800,
        },
        {
            order: 12,
            speaker: 'user',
            text: 'Sí.',
            timestamp_ns: 1767809509447718400,
        },
        {
            order: 13,
            speaker: 'assistant',
            text: 'Okay, bueno, eso es potencialmente una MUY buena noticia, porque podría ayudar al Abogado a arreglar tus papeles sin que tengas que salir del país. Ahora, ¿tienes algún hijo que sea ciudadano de los Estados Unidos y mayor de 21 años?',
            timestamp_ns: 1767809523200614400,
        },
        {
            order: 14,
            speaker: 'user',
            text: 'Sí.',
            timestamp_ns: 1767809525987762700,
        },
        {
            order: 15,
            speaker: 'assistant',
            text: 'Okay, aún mejor, eso podría ser muy útil para el Abogado para arreglar tus papeles. Ahora, como muchos de nuestros clientes, ¿usaste un coyote la última vez que entraste a los Estados Unidos?',
            timestamp_ns: 1767809535873235000,
        },
        {
            order: 16,
            speaker: 'user',
            text: 'Sí.',
            timestamp_ns: 1767809538956990200,
        },
        {
            order: 17,
            speaker: 'assistant',
            text: 'Okay, bien, eso también podría ser muy útil para arreglar tus papeles. Ahora, ¿tienes alguna corte pendiente para comparecer ante a un juez de migración?',
            timestamp_ns: 1767809547215484200,
        },
        {
            order: 18,
            speaker: 'user',
            text: 'Sí.',
            timestamp_ns: 1767809550360283600,
        },
        {
            order: 19,
            speaker: 'assistant',
            text: 'Okay, ¿su cita sería dentro de 3 meses o más?',
            timestamp_ns: 1767809553204264000,
        },
        {
            order: 20,
            speaker: 'user',
            text: 'K.',
            timestamp_ns: 1767809556761346800,
        },
        {
            order: 21,
            speaker: 'assistant',
            text: 'Perfecto. ¿Y en qué estado sería esa corte? ¿Sería en California o Texas?',
            timestamp_ns: 1767809561225658600,
        },
        {
            order: 22,
            speaker: 'user',
            text: 'Fix it.',
            timestamp_ns: 1767809565385423400,
        },
        {
            order: 23,
            speaker: 'assistant',
            text: 'Perfecto, eso es excelente noticia. Basado en eso, parece que podrías ser un excelente candidato para arreglar tus papeles sin salir del país. Entonces, si me permites, te voy a transferir ahora mismo con uno de nuestros representantes junior, quien te explicará los siguientes pasos y lo fácil que es comenzar. ¿Te parece bien?',
            timestamp_ns: 1767809583526811400,
        },
        {
            order: 24,
            speaker: 'user',
            text: 'Regular.',
            timestamp_ns: 1767809585917803800,
        },
        {
            order: 25,
            speaker: 'assistant',
            text: 'Okay, entiendo completamente que estés ocupado ahora mismo, pero esto solo tomará unos momentos. Y nuevamente, parece que potencialmente calificas para arreglar tus papeles sin tener que salir del país. Entonces, si tienes solo un momento, puedo transferir la llamada ahora mismo a un representante junior. No tardará mucho, ¿te parece bien?',
            timestamp_ns: 1767809604333724700,
        },
        {
            order: 26,
            speaker: 'user',
            text: 'Vale.',
            timestamp_ns: 1767809606345524200,
        },
    ];

    const entries_lifex = [
        {
            order: 1,
            speaker: 'user',
            text: 'Hello?',
            timestamp_ns: 1768247730344992000,
        },
        {
            order: 2,
            speaker: 'assistant',
            text: "Hi, Lucas, this is Laura? from Compass Health Insurance? How's it GOING today!",
            timestamp_ns: 1768247734448408300,
        },
        {
            order: 3,
            speaker: 'user',
            text: 'Doing fine.',
            timestamp_ns: 1768247736834919700,
        },
        {
            order: 4,
            speaker: 'assistant',
            text: "AWESOME, that's GREAT to hear. Now, I believe you JUST filled out a form on either Facebook or instagram, requesting information on self-employed health insurance? Well, there's a new plan that 'just' came out, and the monthly premiums are forty percent lower than ANYTHING we've seen, and the coverage is FANTASTIC! Are you still looking?",
            timestamp_ns: 1768247754178433500,
        },
        {
            order: 5,
            speaker: 'user',
            text: 'Yes.',
            timestamp_ns: 1768247756278966300,
        },
        {
            order: 6,
            speaker: 'assistant',
            text: "Excellent, well you've DEFINITELY come to the right place! Now, two quick things before we dive in: first, I just want you to know that I'm an advanced AI trained on ALL things health insurance, and I promise to do an AMAZING job for you. And second? we record these calls for training purposes. Now, are you looking for coverage just for yourself? or is it also for a spouse or any dependents.",
            timestamp_ns: 1768247776661400300,
        },
        {
            order: 7,
            speaker: 'user',
            text: 'Calling for myself.',
            timestamp_ns: 1768247779049729800,
        },
        {
            order: 8,
            speaker: 'assistant',
            text: 'Perfect; so tell me a little bit about your current situation, what has you looking for coverage right now?',
            timestamp_ns: 1768247784335853600,
        },
        {
            order: 9,
            speaker: 'user',
            text: 'Changing curves.',
            timestamp_ns: 1768247786740402200,
        },
        {
            order: 10,
            speaker: 'assistant',
            text: "Understood Now, in terms of your new plan, do you have a certain dollar-amount in mind for what you'd like your new monthly premium to be?",
            timestamp_ns: 1768247794289320700,
        },
        {
            order: 11,
            speaker: 'user',
            text: 'Not really.',
            timestamp_ns: 1768247796780622600,
        },
        {
            order: 12,
            speaker: 'assistant',
            text: "Okay, thanks for sharing that. So, for solid PPO coverage? you're looking at a monthly premium of as little as three hundred dollars and as much as six hundred dollars, depending on the plan. I'll explain everything to you shortly, but for now, how does that range sound to you?",
            timestamp_ns: 1768247810831712800,
        },
        {
            order: 13,
            speaker: 'user',
            text: 'Sounds good.',
            timestamp_ns: 1768247812884232200,
        },
        {
            order: 14,
            speaker: 'assistant',
            text: 'Perfect; now, I just need your age, please so I can pull some accurate quotes.',
            timestamp_ns: 1768247817809576000,
        },
        {
            order: 15,
            speaker: 'user',
            text: '25.',
            timestamp_ns: 1768247822166581200,
        },
        {
            order: 16,
            speaker: 'assistant',
            text: "Great, well, I think we can DEFINITELY help you get some FANTASTIC coverage at a VERY affordable rate. So, with that in mind, why don't you tell me a little bit about how you typically use health insurance? Is it mostly for annual checkups and random illnesses, or do you tend to use it more frequently?",
            timestamp_ns: 1768247837288369000,
        },
        {
            order: 17,
            speaker: 'user',
            text: "I'll look forward in my checkups.",
            timestamp_ns: 1768247841296854300,
        },
        {
            order: 18,
            speaker: 'assistant',
            text: "Understood, now are there any ABSOLUTELY MUST-HAVE doctors or hospitals that we need to make sure are in your new plan's network?",
            timestamp_ns: 1768247847906038000,
        },
        {
            order: 19,
            speaker: 'user',
            text: 'Not really.',
            timestamp_ns: 1768247851479862300,
        },
        {
            order: 20,
            speaker: 'assistant',
            text: "Awesome, let's switch subjects and talk about your overall health for a moment; now, generally speaking, would you say that you're in reasonably good health right now?",
            timestamp_ns: 1768247859737246000,
        },
        {
            order: 21,
            speaker: 'user',
            text: 'Yes.',
            timestamp_ns: 1768247861731153700,
        },
        {
            order: 22,
            speaker: 'assistant',
            text: "Excellent, that's great to hear, and have you had any major health issues in the last five years? like a hospitalization or a serious diagnosis like cancer or heart disease?",
            timestamp_ns: 1768247870528907000,
        },
        {
            order: 23,
            speaker: 'user',
            text: 'No.',
            timestamp_ns: 1768247872133408000,
        },
        {
            order: 24,
            speaker: 'assistant',
            text: "Perfect now, are there any medications you're currently taking that I need to know about?",
            timestamp_ns: 1768247877553819000,
        },
        {
            order: 25,
            speaker: 'user',
            text: 'No.',
            timestamp_ns: 1768247880789596000,
        },
        {
            order: 26,
            speaker: 'assistant',
            text: "Awesome, well, let me say this, Lucas; based on the fact that you're in reasonably good health, there's a VERY POPULAR program that I'm almost SURE you qualify for! and it offers FANTASTIC coverage at VERY affordable rates! It's called the Group Access Health Plan... and it's offered through a nationwide health-research organization named LIFEX. Now... what MAKES this plan SO attractive? is that it allows HEALTHY people like yourself, to get the SAME LOW pricing and comprehensive coverage that's NORMALLY reserved for employees in LARGE corporate health plans... even though you're NOT currently in one. Sound interesting so far?",
            timestamp_ns: 1768247914234173000,
        },
        {
            order: 27,
            speaker: 'user',
            text: 'Yes.',
            timestamp_ns: 1768247916325938000,
        },
        {
            order: 28,
            speaker: 'assistant',
            text: "Excellent; now let me explain EXACTLY how this works. In short... Lifex will allow you to join their existing group benefits plan by hiring you as a VERY-VERY part-time employee in their research division. Now, in terms of what your JOB will be, as one of these VERY part-time employees? All you have to do is complete a couple of short, online surveys each year. That's it, Lucas. They take maybe five to ten minutes TOPS, and Lifex will actually PAY you ten dollars for each one you complete! And because they'll be paying you as a W-2 employee? you'll now qualify to join their existing group health plan... which has that FANTASTIC coverage and VERY AFFORDABLE rates. Make sense?",
            timestamp_ns: 1768247951534980400,
        },
        {
            order: 29,
            speaker: 'user',
            text: 'Yeah.',
            timestamp_ns: 1768247953262371800,
        },
        {
            order: 30,
            speaker: 'assistant',
            text: 'Awesome, so with that in mind, let me take you through the actual plan and explain ALL the key benefits and also answer any questions you may have; sound good?',
            timestamp_ns: 1768247962542448400,
        },
        {
            order: 31,
            speaker: 'user',
            text: 'Sounds good.',
            timestamp_ns: 1768247964611114000,
        },
        {
            order: 32,
            speaker: 'assistant',
            text: "Excellent; now, for starters? your network will be Cigna, which is one of the LARGEST and most WELL-respected PPO networks in the ENTIRE country. In fact, they have over FIVE thousand hospitals and one point-five MILLION doctors nationwide, so you'll have absolutely NO problem finding some AMAZING providers there. Sound good so far?",
            timestamp_ns: 1768247982827931600,
        },
        {
            order: 33,
            speaker: 'user',
            text: 'Yeah.',
            timestamp_ns: 1768247984325226500,
        },
        {
            order: 34,
            speaker: 'assistant',
            text: 'Awesome now, firstly, I want you to know that this is a FULL-BLOWN major medical plan with UNLIMITED protection! It has a low annual deductible of just one thousand five hundred dollars and a VERY AFFORDABLE monthly premium of only three hundred and sixty-nine dollars. Now, based on what you said before, Lucas? I think this amount fits PERFECTLY into your budget. Correct?',
            timestamp_ns: 1768248004144276200,
        },
        {
            order: 35,
            speaker: 'user',
            text: 'Yeah.',
            timestamp_ns: 1768248005723496400,
        },
        {
            order: 36,
            speaker: 'assistant',
            text: "Perfect; now, we REFER to this type of plan as an E-P-O, which stands for EXCLUSIVE provider network; and what that MEANS, Lucas? is that you'll have access to Cigna's ENTIRE extended PPO network - which, again, has that HUGE national footprint of over FIVE-thousand hospitals and one-point-five MILLION doctors. You follow me so far?",
            timestamp_ns: 1768248025753888800,
        },
        {
            order: 37,
            speaker: 'user',
            text: 'Yeah.',
            timestamp_ns: 1768248027530874600,
        },
        {
            order: 38,
            speaker: 'assistant',
            text: "Excellent; now, the only time you can go 'OUT' of network with this plan? is for an emergency. In that case, you can go to any hospital and be FULLY covered... no questions asked. Does that make sense?",
            timestamp_ns: 1768248038445605000,
        },
        {
            order: 39,
            speaker: 'user',
            text: 'Yes.',
            timestamp_ns: 1768248040792282000,
        },
        {
            order: 40,
            speaker: 'assistant',
            text: "Awesome... let's continue. Now, when you start actually USING your plan? you'll find one of its most ATTRACTIVE features is that LOW annual deductible of one thousand five hundred dollars. Now, how familiar ARE you with the way deductibles work?",
            timestamp_ns: 1768248055103018800,
        },
        {
            order: 41,
            speaker: 'user',
            text: 'Very familiar. Yeah.',
            timestamp_ns: 1768248060392447700,
        },
        {
            order: 42,
            speaker: 'assistant',
            text: "Perfect; so I'll just give you the highlights. Now, firstly... like ALL major medical plans? you'll have a maximum out of pocket of nine thousand two hundred dollars each year. So... let's say disaster strikes, and you get hit with a one-hundred-thousand-dollar hospital bill. In this case, all you'll be responsible for is that first one thousand five hundred dollars to cover your deductible. Then... with THIS plan, instead of coinsurance, you'll have a fixed copay of two thousand five hundred dollars which covers the ENTIRE bill for the REST of your stay. So... despite getting hit with that insanely high hospital bill? all YOU had to pay was four thousand dollars; and rest of the bill was covered by insurance. Does that make sense?",
            timestamp_ns: 1768248098881760800,
        },
        {
            order: 43,
            speaker: 'user',
            text: 'Yeah.',
            timestamp_ns: 1768248100527012000,
        },
        {
            order: 44,
            speaker: 'assistant',
            text: "Perfect; now, let's move on to your day-to-day coverage... starting with your annual WELLNESS visit, which, with THIS particular plan, is free! There's NO copay, NO deductible to meet, and NO charge for any routine test the doctor orders. For example... things like colonoscopies, mammograms, X-rays, or any blood work that's needed; in fact, there are actually sixty-four different preventative measures that COME with this visit, and like everything else, all of them are free. Sound good so far?",
            timestamp_ns: 1768248126118707500,
        },
        {
            order: 45,
            speaker: 'user',
            text: 'Sounds good.',
            timestamp_ns: 1768248127919204400,
        },
        {
            order: 46,
            speaker: 'assistant',
            text: "Great... let's move on to prescriptions. In THIS case, the plan has VERY RICH coverage on ALL generics. And, just like your annual WELLNESS visit? all of your medications are FREE. There's NO deductible to meet and NO copay; Now, if you take any long-term maintenance medications? the plan uses a mail-order pharmacy that'll send you a three-month supply, so you don't have to waste time going to the drug store each month. And then, for your short-term prescriptions? your doctor can simply call them in, and you can fill them at the local pharmacy at no charge. Sound good so far?",
            timestamp_ns: 1768248156800083000,
        },
        {
            order: 47,
            speaker: 'user',
            text: 'All good.',
            timestamp_ns: 1768248158623750100,
        },
        {
            order: 48,
            speaker: 'assistant',
            text: "Excellent; now, like ALL health plans, there IS a formulary with this one, so if the doctor DOES need to prescribe something, just make sure they check the formulary and choose the generic version, because the plan doesn't include brand name drugs. This way, you won't run into any issues at the local pharmacy. Does that make sense?",
            timestamp_ns: 1768248176531211000,
        },
        {
            order: 49,
            speaker: 'user',
            text: 'Makes sense.',
            timestamp_ns: 1768248178338054100,
        },
        {
            order: 50,
            speaker: 'assistant',
            text: "Perfect; now, let's move on to the plan's most POPULAR program of all, unlimited telemedicine visits... which, like your annual wellness visit AND your prescriptions, is also free. Now, have you ever used telemedicine before?",
            timestamp_ns: 1768248191441742800,
        },
        {
            order: 51,
            speaker: 'user',
            text: 'No.',
            timestamp_ns: 1768248194622947600,
        },
        {
            order: 52,
            speaker: 'assistant',
            text: "Okay, well, let me explain: Now... for starters, with THIS particular plan... not only do you get UNLIMITED telemedicine visits but the service is available to you twenty-four hours a day! So, let's say you catch a cold or get the flu or your allergies are acting up and you don't feel like going to the doctor; all you have to do is dial the telemedicine line or click on a link and, just like THAT, you'll be speaking to one. They can diagnose you... call in any prescriptions you need... and again, there's absolutely NO copay and NO deductible with this service. Your insurance covers EVERYTHING. Does that sound good?",
            timestamp_ns: 1768248225041485800,
        },
        {
            order: 53,
            speaker: 'user',
            text: 'Sounds good.',
            timestamp_ns: 1768248227274320000,
        },
        {
            order: 54,
            speaker: 'assistant',
            text: "Perfect; well, unfortunately... not EVERYTHING on your plan can be free, so when it comes to the REST of your day-to-day coverage, you'll have a series of SMALL copays that kick-in once you've hit your deductible. For example... let's say you get sick and need to see the doctor. In this case, the copay for an office visit will be fifty dollars. You follow me so far?",
            timestamp_ns: 1768248244649313000,
        },
        {
            order: 55,
            speaker: 'user',
            text: 'Yes.',
            timestamp_ns: 1768248246716576500,
        },
        {
            order: 56,
            speaker: 'assistant',
            text: 'Great; now, in addition, this fifty-dollar copay ALSO applies to any specialists you see. And on the E-P-O plan? you do NOT need a referral from your primary care doctor to see ANY specialist in the network. You can see whoever you want, as MUCH as you want... which allows you to manage your healthcare in ANY way you see fit. Does that sound good?',
            timestamp_ns: 1768248265436804400,
        },
        {
            order: 57,
            speaker: 'user',
            text: 'Sounds good.',
            timestamp_ns: 1768248267698825500,
        },
        {
            order: 58,
            speaker: 'assistant',
            text: "Perfect; now, I don't want to overwhelm you with lots of numbers, but if you'll bear with me for just a moment, let me give you a few more sample copays so you get the full picture. So, with that in mind... if you go to a local urgent care center, your copay for that will be fifty dollars. And if you need to do blood work, then your copay will be twenty-FIVE dollars. If your doctor needs an X-ray, it'll be fifty dollars. If you have to go to the emergency room god forbid... then your copay on that will be one-thousand dollars. And if you want to see a chiropractor or a physical therapist, then your copay for those services will be fifty dollars. And in ALL those cases, everything AFTER that will be covered by insurance. Does all of that make sense?",
            timestamp_ns: 1768248304546107600,
        },
        {
            order: 59,
            speaker: 'user',
            text: 'Yep.',
            timestamp_ns: 1768248306412621600,
        },
        {
            order: 60,
            speaker: 'assistant',
            text: "Excellent; so... THAT'S the E-P-O plan in a nutshell. And again... what makes this plan SO attractive is that on top of ALL those FREE services - the annual wellness visit, the free prescriptions, the unlimited telemedicine? at the end of the day, it's basically two, AWESOME plans in one! You have those small, fixed copays, to manage your day-to-day coverage, and the TOTAL peace of mind that comes from that GUARANTEED safety net for if things REALLY hit the fan! AND with a monthly payment of only three hundred and sixty-nine dollars... I mean, personally, Lucas... I don't see how you can go wrong. Does everything sound good so far?",
            timestamp_ns: 1768248340349471700,
        },
        {
            order: 61,
            speaker: 'user',
            text: 'Sounds good.',
            timestamp_ns: 1768248342234745300,
        },
        {
            order: 62,
            speaker: 'assistant',
            text: "Great, Lucas. The final step of the process is to get you approved. So, I'm going to transfer you to one of our human agents to ask you a few questions to make sure you qualify as a research associate for Lifex. Can you hold for just a moment while I get someone on the line?",
            timestamp_ns: 1768248356279075600,
        },
        {
            order: 63,
            speaker: 'user',
            text: 'Sure.',
            timestamp_ns: 1768248360149053200,
        },
        {
            order: 64,
            speaker: 'assistant',
            text: 'Perfect, Lucas, hold on for just a moment while I transfer the call.',
            timestamp_ns: 1768248364425387300,
        },
    ];

    return entries_lifex;
};
